import React from 'react';
import AdminRouteGuard from '../../components/guards/AdminRouteGuard';
import CreateSystemUserPage from './CreateSystemUserPage';

const CreateSystemUserPageWrapper: React.FC = () => {
  return (
    <AdminRouteGuard>
      <CreateSystemUserPage />
    </AdminRouteGuard>
  );
};

export default CreateSystemUserPageWrapper;